import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronUpOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6 3.375 3.75 3.75-.742.742L6 4.86 2.992 7.868l-.742-.743z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronUpOutlinedSize12Glyph.displayName = 'ChevronUpOutlinedSize12Glyph';
